// extracted by mini-css-extract-plugin
module.exports = {"UiPill":"pill_UiPill__MWKSW","UiPill__label":"pill_UiPill__label__k6ScP"};